import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { SampleModel } from './../../models/mocks/compliance-central-reports';
const equal = require('deep-equal');

// eslint-disable-next-line
export const getScrollbarWidth: any = function () {
  var div, width = getScrollbarWidth.width;
  if (!width) {
    div = document.createElement('div');
    div.innerHTML = '<div style="width:50px; height:50px; position:absolute; left:-50px; top:-50px; overflow:auto;"><div style="width: 1px; height: 100px;"></div></div>';
    div = div.firstChild;
    document.body.appendChild(div);
    width = getScrollbarWidth.width = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }
  return width;
};

@Component({
  selector: 'datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit {
  @Input() active;
  _active;
  columnDetailsByName = {};
  currentSortColumn = {
    desc: false,
    key: null,
    element: null,
    name: null,
    type: null
  };
  private _columns = {};
  @Input() columns: Object = [];
  currentColumns: Object = [];
  @Output() onRowClicked = new EventEmitter();
  @Output() onCellClicked = new EventEmitter();
  @Output() onOptionClicked = new EventEmitter();
  @Input() options: Array<Object> = [];
  @Input() rowMeta: any = [];
  private _rows = [];
  @Input() rows: Array<Object> = [];
  @Input() selectable = undefined;
  @Input() selectedRow: Number = -1;
  sortedRows: Array<any> = [];
  sortedAndFilteredRows: Array<any> = [];
  sortedAndFilteredRowMeta: any = [];
  tableDisplay = 'block';
  @ViewChild('table') tableRef;
  widths = null;

  constructor() { }

  /**
   * @todo This looks like duplicate of ngOnChanges
   */
  ngOnInit(): void {
    this.active = true;
    this.initializeRows();
    this.parseColumns();
    this.parseRows();
    this.getColumnDetails();
    this.calcWidths();
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.calcHeight(true);
        this.adjustWidths(true);
      });
    });
  }

  /**
   * @todo This looks like duplicate of ngOnInit
   */
  async ngOnChanges() {
    this.initializeRows();
    this.parseColumns();
    this.parseRows();
    this.getColumnDetails();
    if (!this.widths ||
      Object.keys(this.widths).length !== Object.keys(this._columns).length) {
      this.calcWidths();
    }
    if (this.active && !this._active) {
      this.adjustWidths(true);
    }
    this._active = this.active;
    this.adjustForHorizontalScroll();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.calcWidths();
      this.adjustWidths(true);
    });
  }

  /**
   * Adjusts the widths of the tbody to match the horizontal scroll of the
   * table without triggering overflow scrollbars.
   */
  adjustWidths(isResize = false) {
    this.adjustForHorizontalScroll(true);
    const table = this.tableRef.nativeElement;
    const thead = table.querySelector('thead');
    const scrollLeft = table.scrollLeft;
    const tbody = this.tableRef.nativeElement.querySelector('tbody');
    if (table.clientWidth > 0 &&
      (!tbody.hasAttribute('data-width') || isResize)) {
      let width = table.clientWidth;
      if (tbody.scrollHeight > tbody.clientHeight) {
        width += getScrollbarWidth();
      }
      tbody.setAttribute('data-width', width);
    }
    let newWidth = Number(tbody.getAttribute('data-width')) + scrollLeft;
    if (tbody.scrollHeight > tbody.clientHeight) {
      newWidth -= getScrollbarWidth();
    }
    let width = Math.max(table.clientWidth,
      Math.min(Number(thead.clientWidth), newWidth));
    tbody.style.width = `${width}px`;
    if (tbody.clientHeight > (table.clientHeight - thead.clientHeight)) {
      // TODO: This might be a flaky condition, implemented for transactions table.
      this.adjustTBodyHeight(isResize);
    }
  }

  /**
   * Adjusts for when table moves between being in a horizontal scroll vs.
   * not.
   */
  adjustForHorizontalScroll(noReadjust = false) {
    const table = this.tableRef.nativeElement;
    const thead = table.querySelector('thead');
    const tbody = this.tableRef.nativeElement.querySelector('tbody');
    const oldTableDisplay = this.tableDisplay;
    this.tableDisplay = this.hasHorizontalScroll() ? 'table-row' : 'block';
    if (this.tableDisplay === 'block') {
      // When switching back to a block display, need width set to auto.
      tbody.style.width = 'auto';
    } else if (tbody.clientHeight > (table.clientHeight - thead.clientHeight)) {
      // TODO: This might be a flaky condition, implemented for transactions table.
      this.adjustTBodyHeight();
    }
    // Fixes bug on CC page.
    if (oldTableDisplay !== this.tableDisplay) {
      if (this.tableDisplay === 'block') {
        this.calcWidths();
      } else if (!noReadjust) {
        this.adjustWidths();
      }
    }
  }

  /**
   * Adjusts the tbody height such that the vertical scrollbar properly matches
   * the height of the table, overall.  This generally should only apply where
   * the table height is specified via CSS (such as on transactions page).
   * @param isResize
   */
  adjustTBodyHeight(isResize = false) {
    const table = this.tableRef.nativeElement;
    const thead = table.querySelector('thead');
    const tbody = this.tableRef.nativeElement.querySelector('tbody');
    if (table.clientHeight > 0 &&
      (!tbody.hasAttribute('data-height') || isResize)) {
      let height = (table.clientHeight - thead.clientHeight);
      if (thead.clientWidth > table.clientWidth) {
        height -= getScrollbarWidth();
      }
      tbody.setAttribute('data-height', height);
    }
    let height = Number(tbody.getAttribute('data-height'));
    if (thead.clientWidth > table.clientWidth) {
      // height -= getScrollbarWidth();
    }
    tbody.style.height = height + 'px';
  }

  /**
   * Calculates the height based on the window height (not document height) and
   * the offset of the table object.
   * @todo This should go into a parent container.
   */
  calcHeight(forceRedraw = false) {
    const windowHeight = document.documentElement.clientHeight;
    const tbody = this.tableRef.nativeElement.querySelector('tbody');
    const tbodyOffset = this.tableRef.nativeElement.offsetTop + tbody.offsetTop;

    // If horizontal scroll exists, then adjust for scrollbar width.
    if (document.body.clientWidth) {
      // TODO: Adjust for height.
    }

    if (forceRedraw || !tbody.adjustedHeight) {
      tbody.adjustedHeight = true;
      tbody.style.height = (windowHeight - tbodyOffset - 2) + 'px';
    }
  }

  /**
   * Calculates the widths.  This involves taking the largest width cell for
   * each column and adjusting the widths of the respective cells in that column
   * to that particular width.
   */
  calcWidths() {
    const widths = {};
    const query = this.tableRef.nativeElement.querySelectorAll('thead tr, tbody tr');
    query.forEach((trEl) => {
      for (let idx = 0; idx < trEl.cells.length; idx++) {
        const tdEl = trEl.cells[idx];
        if (!widths[idx] || tdEl.clientWidth > widths[idx]) {
          if (this.widths && this.widths[idx] && this.widths[idx] > tdEl.clientWidth) {
            widths[idx] = this.widths[idx];
          } else {
            widths[idx] = tdEl.clientWidth;
          }
        }
      }
    });

    this.widths = widths;
  }

  /**
   * Filters out rows unless they match a wildcard bound token for the column
   * search.
   */
  filterColumn(column, searchText) {
    const key = Object.keys(this._columns).find((col) => {
      return this._columns[col].name === column;
    });
    if (this._columns[key]) {
      this._columns[key].searchText = searchText;
    }
    this.filterRows();
  }

  /**
   * Filters out rows, and optionally will only run filtering on the provided
   * key to increase speed of processing.
   */
  filterRows() {
    this.sortedAndFilteredRows = [].concat(this.sortedRows);
    Object.keys(this.columnDetailsByName).map((name) => {
      const key = this.columnDetailsByName[name].key;
      const search = this._columns[key].searchText;
      if (search) {
        this.sortedAndFilteredRows = this.sortedAndFilteredRows.filter((row) => {
          const val = row[key];
          switch (this.columnDetailsByName[name].type) {
            case 'htmlelement':
              return !!val.textContent.match(new RegExp(`.*${search}.*`, 'gi'));
            default:
              return !!val.toString().match(new RegExp(`.*${search}.*`, 'ig'));
          }
        });
      }
    });
    this.generateRowMeta();
  }

  /**
   * Gets the expanded column object which includes state information about that
   * column.
   */
  getColumnDetails() {
    const columns = this.getColumns();
    columns.forEach((column) => {
      column = column.name;
      const key = Object.keys(this._columns).find((col) => {
        return this._columns[col].name === column;
      });
      if (!this.columnDetailsByName[column]) {
        this.columnDetailsByName[column] = {
          desc: false,
          key: key,
          type: this.getColumnType(key),
          value: column
        };
      } else {
        this.columnDetailsByName[column].type = this.getColumnType(key);
      }
    });
    return this.columnDetailsByName;
  }

  /**
   * Returns the display names for the columns.
   */
  getColumns(): Array<any> {
    return Object.keys(this._columns).map((key) => this._columns[key]);
  }

  /**
   * Gets the implicit type of this field.
   */
  getColumnType(name) {
    let i = 0;
    if (!this._rows || this._rows.length === 0) {
      return 'string';
    }
    while ((!this._rows[i] || this._rows[i][name] === null ||
      this._rows[i][name] === undefined) &&
      i < this._rows.length) { i++; }
    if (!this._rows[i] || !this._rows[i][name]) {
      return 'string';
    }
    if (this._rows[i][name] instanceof HTMLElement) {
      return 'htmlelement';
    }
    if (!isNaN(Number(this._rows[i][name].replace(/,/g, '')))) {
      return 'number';
    }
    if (!isNaN((new Date(this._rows[i][name])).getTime())) {
      return 'date';
    }
    return 'string';
  }

  /**
   * Gets the values given some row.
   */
  getRowValues(row) {
    const values = [];
    for (let key in this._columns) {
      if (row.hasOwnProperty(key)) {
        if (typeof row[key] === 'function') {
          values.push(row[key]() || '');
        } else if (row[key] instanceof HTMLElement) {
          values.push(row[key].outerHTML);
        } else {
          values.push(row[key]);
        }
      } else {
        values.push('');
      }
    }

    return values;
  }

  /**
   * Gets the width of a row, given all the other rows.
   */
  getWidth(j) {
    if (this.widths && this.widths[j]) {
      const thead = this.tableRef.nativeElement.querySelector('thead');
      const tbody = this.tableRef.nativeElement.querySelector('tbody');
      if (tbody.offsetHeight < tbody.scrollHeight) {
        thead.style.paddingRight = getScrollbarWidth() + 'px';
      } else {
        thead.style.paddingRight = '0px';
      }
      return this.widths[j] + 'px';
    }
  }

  /**
   * If there is a horizontal scrollbar.
   */
  hasHorizontalScroll() {
    return this.tableRef.nativeElement.clientWidth <
      this.tableRef.nativeElement.scrollWidth;
  }

  /**
   * This fills the rows with defaults so the component doesn't break.
   */
  initializeRows() {
    if (this.rows.length === 0 && Object.keys(this.columns).length === 0) {
      this.rows = SampleModel;
    } else if (Object.keys(this.columns).length === 0) {
      this.parseColumnsFromRows();
    }
  }

  /**
   * Called when a row is clicked on.
   */
  onRowClick({ row, index }) {
    if (this.selectable !== undefined) {
      this.selectedRow = row.id;
      this.onRowClicked.emit({ row, index });
    }
  }

  /**
   * Parses the rows from incoming data.
   */
  parseColumns() {
    if (!this._columns || !equal(this.currentColumns, this.columns)) {
      this.currentColumns = this.columns;
      this._columns = {};
      Object.keys(this.columns).map((key) => {
        let column = this.columns[key];
        if (typeof column === 'string') {
          column = {
            name: column,
            searchable: false,
            searchText: ''
          };
        }
        this._columns[key] = column;
        if (!this._columns[key].searchText) {
          this._columns[key].searchText = '';
        }
        return column;
      });

      this.columnDetailsByName = {};
      this.sortColumn({
        column: this._columns[Object.keys(this._columns)[0]].name
      });
    }
  }

  /**
   * Note: Sometimes this can create a slowdown if the number of rows is large.
   * This can be avoided by simply providing a `columns` input.
   */
  parseColumnsFromRows() {
    let cols = {};
    for (let row of this.rows) {
      Object.keys(row).forEach((key) => !cols[key] ? cols[key] = key : false);
    }
    this.columns = cols;
  }

  /**
   * Parses the rows from incoming data.
   */
  parseRows() {
    if (!this._rows || !equal(this.rows, this._rows)) {
      this._rows = [].concat(this.rows).map((row) => {
        row = Object.assign({}, row);
        return row;
      });
      this.sortedRows = [].concat(this._rows).map((row, idx) => {
        row = Object.assign({}, row); // Need this!
        row.id = idx;
        return row;
      });
      this.sortedAndFilteredRows = [].concat(this.sortedRows);
      setTimeout(() => {
        this.calcHeight();
        this.adjustWidths();
      });
    }
    this.generateRowMeta();
  }

  /**
   * Sorts a given column.  If another column is already being sorted, then
   * remove that column as the active sort column.
   */
  sortColumn(event) {
    const columns = this.getColumnDetails();
    if (this.currentSortColumn.name && this.currentSortColumn.name === event.column) {
      // Same column, flip it to descending.
      columns[event.column].desc = !columns[event.column].desc;
      this.currentSortColumn.desc = columns[event.column].desc;
    } else {
      // if (this.currentSortColumn.element) {
      //   this.currentSortColumn.element.classList.remove('active');
      // }
      this.currentSortColumn.name = event.column;
      this.currentSortColumn.desc = columns[event.column].desc;
      this.currentSortColumn.key = columns[event.column].key;
      this.currentSortColumn.type = columns[event.column].type;
      // this.currentSortColumn.element = event.element;
      // this.currentSortColumn.element.classList.add('active');
    }

    this.sortRows();
    this.filterRows();
  }

  /**
   * Performs row sorting by type, given the `currentSortColumn`.
   */
  sortRows() {
    const desc = this.currentSortColumn.desc ? -1 : 1;
    this.sortedRows.sort((aRow, bRow) => {
      const aCol = aRow[this.currentSortColumn.key];
      const bCol = bRow[this.currentSortColumn.key];
      if (aCol === bCol) {
        return 0;
      }
      switch (this.getColumnType(this.currentSortColumn.key)) {
        case 'htmlelement':
          if (aCol === null || aCol === undefined) {
            return 1;
          }
          return aCol.textContent.localeCompare(bCol.textContent) * desc;
        case 'number':
          if (aCol === null || aCol === undefined) {
            return 1;
          }
          const aNumber = aCol === 0 ? 0 : Number(aCol.replace(/,/g, ''));
          const bNumber = bCol === 0 ? 0 : Number(bCol.replace(/,/g, ''));
          return (aNumber > bNumber ? 1 : -1) * desc;
        case 'date':
          if (aCol === null || aCol === undefined) {
            return 1;
          }
          const aDate = (new Date(aCol).getTime());
          const bDate = (new Date(bCol).getTime());
          return (aDate > bDate ? 1 : -1) * desc;
        case 'string':
        default:
          if (aCol === null || aCol === undefined) {
            return 1;
          }
          return aCol.localeCompare(bCol) * desc;
      }
    });
  }

  generateRowMeta(): void {
    this.sortedAndFilteredRowMeta = [];
    this.sortedAndFilteredRows.forEach((row) => {
      this.sortedAndFilteredRowMeta.push(this.rowMeta[row.id]);
    });
  }
}
